/* __next_internal_client_entry_do_not_use__ Tag auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Spacer } from "../spacing";
import { Pill, Label, CloseButton } from "./styled";
/**
 * @trackcomponent
 *
 * @link [Docs](https://slate.faire.team/slate/component/tag)
 */ export var Tag = function(param) {
    var label = param.label, onClick = param.onClick, onClose = param.onClose, dataTestId = param["data-test-id"];
    return /*#__PURE__*/ _jsxs(Pill, {
        onClick: onClick,
        "data-test-id": dataTestId !== null && dataTestId !== void 0 ? dataTestId : label,
        children: [
            /*#__PURE__*/ _jsx(Label, {
                children: label
            }),
            onClose ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: 4
                    }),
                    /*#__PURE__*/ _jsx(CloseButton, {
                        onClose: onClose,
                        "data-test-id": "close-".concat(dataTestId !== null && dataTestId !== void 0 ? dataTestId : label)
                    })
                ]
            }) : /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            })
        ]
    });
};
